<template>
  <el-row id="app">
    <el-col :span="24">
      <div id="myGoodsInD" :style="{width: '100%', height: '800px'}"></div>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: "LastYearInTrade",
  data() {
    return {
      //msg: 'Welcome to Your Vue.js App',
      titleText: "进口商品贸易类别统计",
      textStyle: {
        color: "#ccc",
        fontStyle: "normal",
        fontWeight: "bold",
        fontFamily: "sans-serif",
        fontSize: 12
      },
      legendPadding: [65, 5, 15, 5],
      data1: [],
      data2: [],
      lineNumber: 30,
      fullName: ""
    };
  },
  computed: {
    myYear() {
      return this.$store.state.myYear;
    },
    myCountry() {
      return this.$store.state.myCountry;
    }
  },
  watch: {
    myYear(curval, oldval) {
      this.listA();
    },
    myCountry(curval, oldval) {
      this.listA();
    }
  },
  mounted() {
    this.listA();
    //this.drawLine();
  },

  methods: {
    myFormat(params) {
      // console.log('b',params);
      var newParamsName = "";
      var paramsNameNumber = params.length;
      var provideNumber = this.lineNumber;
      var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
      if (paramsNameNumber > provideNumber) {
        for (var p = 0; p < rowNumber; p++) {
          var tempStr = "";
          var start = p * provideNumber;
          var end = start + provideNumber;
          if (p == rowNumber - 1) {
            tempStr = params.substring(start, paramsNameNumber);
          } else {
            tempStr = params.substring(start, end) + "\n";
          }
          newParamsName += tempStr;
        }
      } else {
        newParamsName = params;
      }

      //console.log('a', newParamsName)
      return newParamsName;
    },
    listA() {
      this.titleText = this.$route.query.name +
        "进口商品贸易类别统计" + "-" + this.myYear + "-" + this.myCountry;

      if(this.$route.query.code) {
        var code = this.$route.query.code;
      }

      this.$ajax({
        method: "get",
        url: "/cee/rest/web/hsAnalysisD",
        params: {
          code: code,
          year: this.myYear,
          country: this.myCountry,
          ieflag: "1",
          limit: "30"
        }
      })
        .then(resp => {
          var res1 = [];
          var res2 = [];

          for (let index = 0; index < resp.data.length; index++) {
            let element = resp.data[index];
            res1.push(element.name);
            res2.push((element.price / 10000.0).toFixed(2));
          }
          this.data1 = res1.reverse();
          this.data2 = res2.reverse();
          this.drawLine();
        })
        .catch(err => {});
    },
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      let myGoodsInD = this.$echarts.init(
        document.getElementById("myGoodsInD"),
        "chalk"
      );
      myGoodsInD.setOption({
        title: {
          text: this.titleText,
          left: "left",
          textStyle: this.textStyle
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          },
          formatter(value) {
            // console.log(value);
            return value[0].seriesName + ": " + value[0].value + '万元';
          }
        },
        legend: {
          data: ["贸易额"]
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: {
          type: "value",
          boundaryGap: [0, 0.1]
        },
        yAxis: {
          type: "category",
          data: this.data1,
          axisTick: {
            inside: true
          },
          scale: true,
          axisLabel: {
            interval: 0,
            formatter: this.myFormat
          }
        },
        series: [
          {
            name: "贸易额",
            type: "bar",
            barWidth: 10,
            data: this.data2
          }
        ]
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/GoodsInD.vue